import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { Shipment } from '../models/shipment.model';
import { ShipmentsService } from "../services/shipments.service"
import { AuthService } from '../services/auth.service';
import { ClientsService } from '../services/clients.service';

@Component({
  selector: 'app-with-pod',
  templateUrl: './with-pod.component.html',
  styleUrls: ['./with-pod.component.css']
})
export class WithPodComponent implements OnInit {
  isLoggedIn$: Observable<boolean>
  shipments: Shipment
  bol;
  client;
  user;

  constructor(private shipmentsService: ShipmentsService, private router: Router, private authService: AuthService, private clientsService: ClientsService ) {
    this.authService.getUserClientPromise2()    
   }

  ngOnInit() { this.onStartup() }

  onStartup() {
    this.isLoggedIn$ = this.authService.isLoggedIn$
    this.authService.user$.subscribe((user:any) => {
      console.log(user)
      this.user = user;
      if(!user.message) {
        if( user.clientid == 0) {
          this.getShipments(user.clientid);
          this.authService.client$.subscribe((client) => {
            console.log(client)
            this.client = client;
          });
        }else { 
          this.authService.client$.subscribe((client) => {
            console.log(client)
            this.client = client;
            if(client.cname != 'No Client Selected' && user.clientid != 0){
              this. getShipments(client.clientid);
              }
            })
        }
      }        
    })
  }

  getShipments(clientid){
    if(localStorage.getItem('selectedId') && clientid == 0){
      let clientId = localStorage.getItem('selectedId');
      this.shipmentsService.getShipmentsPOD(clientId)
      .then(shipmentsPod => {
        this.shipments = shipmentsPod
      })
    }else{
      this.shipmentsService.getShipmentsPOD(clientid)
      .then(shipmentsPod => {
        this.shipments = shipmentsPod
      })
    };  

  };

  onBolSearch(){
    this.router.navigate(['/editbol/' + this.bol])
  };

  onSetClient(clientid) {
    // get client info when a client is selected
    this.clientsService.getSelectedClient(clientid)
    .then(response => {
      if(!response.message) {
        let clientarray = response
        this.client = clientarray[0]
      } else {
        console.log(response.message)
        //TODO  create authservice logic for 403 repsone to set user BASE_USER
      }
    });
}

convertDate(date) {
  const dataArray = date.split('-');
  const convDate = dataArray[0] + '/' + dataArray[1] + '/' + dataArray[2];
  return convDate;
       
}

}



// WEBPACK FOOTER //
// ./src/app/with-pod/with-pod.component.ts